var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hp-small-text',[_vm._v("2021 © "),_c('a',{staticStyle:{"color":"#232323","text-decoration":"none"},attrs:{"href":"https://美容ai.com/"}},[_vm._v("ｈａｐｔｉｃｏ, Inc. ")])])}
var staticRenderFns = []

export { render, staticRenderFns }